document.addEventListener('submit', function (event) {
  if (event.target.matches('form[data-nw-wholesale-restricted="true"]')) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true);

(function () {
  var mobileCards = window.matchMedia('(max-width: 720px), (hover: none), (pointer: coarse)');
  var activeCard = null;
  var gesture = null;

  function cardForTarget(target) {
    return target && typeof target.closest === 'function' ? target.closest('.nw-card-exclusive') : null;
  }

  function activateCard(card) {
    if (activeCard === card) return;
    if (activeCard) activeCard.classList.remove('nw-card-exclusive--active');
    activeCard = card;
    if (activeCard) activeCard.classList.add('nw-card-exclusive--active');
  }

  document.addEventListener('touchstart', function (event) {
    if (!mobileCards.matches || event.touches.length !== 1) {
      gesture = null;
      return;
    }

    var card = cardForTarget(event.target);
    if (card !== activeCard) activateCard(null);
    gesture = card ? { card: card, x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
  }, { passive: true });

  document.addEventListener('touchmove', function (event) {
    if (!mobileCards.matches || !gesture || event.touches.length !== 1) return;

    var touch = event.touches[0];
    if (Math.abs(touch.clientX - gesture.x) >= 8 || Math.abs(touch.clientY - gesture.y) >= 8) {
      activateCard(gesture.card);
    }
  }, { passive: true });

  function endGesture() {
    gesture = null;
  }

  document.addEventListener('touchend', endGesture, { passive: true });
  document.addEventListener('touchcancel', endGesture, { passive: true });

  document.addEventListener('wheel', function (event) {
    if (mobileCards.matches && (event.deltaX !== 0 || event.deltaY !== 0)) {
      activateCard(cardForTarget(event.target));
    }
  }, { passive: true });

  document.addEventListener('click', function (event) {
    if (mobileCards.matches && cardForTarget(event.target) !== activeCard) activateCard(null);
  });

  mobileCards.addEventListener('change', function () {
    endGesture();
    activateCard(null);
  });
}());
